import React from "react";
import { modalOverrides, sponsorModal, textModal } from "./common";
export default [
    {
        width: "6.2%",
        height: "13.1%",
        left: "8.5%",
        top: "67.3%",
        label: "SecurityScorecard - Contact us",
        isExternal: true,
        onClick: function () {
            document.getElementById("SecurityScorecard").click();
        }
    },
    {
        width: "5.4%",
        height: "15.1%",
        left: "24%",
        top: "63.3%",
        label: "SecurityScorecard - Instantly Monitor the security health of any organization",
        isExternal: true,
        href: "https://assets.swoogo.com/uploads/2162466-635c29d652d13.pdf",
        target: "_blank"
    },
    {
        width: "3.4%",
        height: "15.1%",
        left: "29.5%",
        top: "63.3%",
        label: "SecurityScorecard - 5 things turbulent times",
        isExternal: true,
        href: "https://assets.swoogo.com/uploads/2162469-635c2a183d381.pdf",
        target: "_blank"
    },
    {
        width: "6.4%",
        height: "7.1%",
        left: "26.5%",
        top: "49.3%",
        label: "SecurityScorecard - Play Content",
        isExternal: true,
        modalOverrides: modalOverrides,
        modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement("iframe", { width: "100%", height: "100%", frameBorder: "0", src: "https://player.vimeo.com/video/764617387?h=ebb8b215a2&autoplay=1", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))
    },
    {
        width: "4%",
        height: "8.6%",
        left: "27.5%",
        top: "38.3%",
        label: "SecurityScorecard - Play Demo",
        isExternal: true,
        modalOverrides: modalOverrides,
        modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement("iframe", { width: "100%", height: "100%", frameBorder: "0", src: "https://player.vimeo.com/video/764619059?h=89c52b8dc3&autoplay=1", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))
    },
    {
        width: "13%",
        height: "6.6%",
        left: "11.5%",
        top: "44.3%",
        label: "SecurityScorecard - Social Media",
        isExternal: true,
        modalOverrides: textModal(),
        modal: sponsorModal("Booth 3", "SecurityScorecard", React.createElement(React.Fragment, null, "Funded by world-class investors including Silver Lake Partners, Sequoia Capital, GV, Riverwood Capital, and others, SecurityScorecard is the global leader in cybersecurity ratings with more than 11 million companies continuously rated. Founded in 2013 by security and risk experts Dr. Aleksandr Yampolskiy and Sam Kassoumeh, SecurityScorecard's patented rating technology is used by over 25,000 organisations for enterprise risk management, third-party risk management, board reporting, due diligence, and cyber insurance underwriting. SecurityScorecard continues to make the world a safer place by transforming the way companies understand, improve and communicate cybersecurity risk to their boards, employees and vendors. Every company has the universal right to their trusted and transparent Instant SecurityScorecard rating."), {
            twitter: "https://twitter.com/security_score",
            facebook: "https://www.facebook.com/SecScorecard",
            instagram: "https://www.instagram.com/securityscorecard/",
            youtube: "https://www.youtube.com/channel/UCbTCXVt5mJTV3eI5_m2chZQ",
            linkedin: "https://www.linkedin.com/company/security-scorecard",
            company: "http://www.securityscorecard.com/"
        })
    }
];
